import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["_id", "name", "description", "image", "gatsbyImage", "imageAltText", "available"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext, useState } from 'react';
import { getContainerClassName } from './ItemContainer.utils';
import { MenuContext, VariantContext, FoodMenuCartContext } from '../../../../FoodMenu.context';
import MenuUtil from '../../../../utils/menu';
import { itemVariantComponentMap, itemModalVariantComponentMap } from '../index';
import '../Item.css';
var defaultProps = {
  displayImages: true
};
export function ItemContainer(_ref) {
  var itemId = _ref.itemId,
    displayImages = _ref.displayImages;
  var _useContext = useContext(VariantContext),
    itemDisplay = _useContext.itemDisplay,
    itemCartModal = _useContext.itemCartModal;
  var _useContext2 = useContext(MenuContext),
    items = _useContext2.items,
    modifierSets = _useContext2.modifierSets,
    modifiers = _useContext2.modifiers;
  var cart = useContext(FoodMenuCartContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  function handleClose() {
    setModalOpen(false);
  }
  function handleOpen() {
    setModalOpen(true);
  }
  function onItemCartModalClick(e, available) {
    var targetClassName = e.target.className;
    // this will enable icons inside the cart container to be clickable and not display the cart modal
    if (targetClassName.includes('icon') && !targetClassName.includes('cart')) {
      e.preventDefault();
      return;
    }
    if (available) {
      handleOpen();
    }
  }
  var ItemComponent = itemVariantComponentMap[itemDisplay];
  var ModalComponent = itemModalVariantComponentMap[itemCartModal];
  var item = MenuUtil.getItemById(items, itemId);
  var _id = item._id,
    name = item.name,
    description = item.description,
    image = item.image,
    gatsbyImage = item.gatsbyImage,
    imageAltText = item.imageAltText,
    _item$available = item.available,
    available = _item$available === void 0 ? true : _item$available,
    restItem = _objectWithoutProperties(item, _excluded);
  var itemModifierSetIds = item.modifierSets;
  var itemModifierSets = MenuUtil.getItemModifierSets(itemModifierSetIds, modifierSets);
  var images = gatsbyImage || image ? [gatsbyImage || image] : [];
  var variations = MenuUtil.getMenuItemVariations(item);
  if (!cart) {
    return /*#__PURE__*/React.createElement(ItemComponent, _extends({
      className: getContainerClassName(item),
      isSingleVariation: MenuUtil.menuItemHasOneVariation(item),
      id: _id,
      name: name,
      description: description,
      image: image,
      imageAltText: imageAltText,
      gatsbyImage: gatsbyImage,
      variations: variations,
      displayImages: displayImages
    }, restItem));
  }
  var addItem = cart.addItem,
    cartLoading = cart.loading;
  return /*#__PURE__*/React.createElement(ModalComponent, {
    trigger: /*#__PURE__*/React.createElement(ItemComponent, _extends({
      className: getContainerClassName(item, available ? ['clickable'] : []),
      onClick: function onClick(e) {
        onItemCartModalClick(e, available);
      },
      isSingleVariation: MenuUtil.menuItemHasOneVariation(item),
      id: _id,
      name: name,
      description: description,
      image: image,
      gatsbyImage: gatsbyImage,
      variations: variations,
      displayImages: displayImages
    }, restItem)),
    open: modalOpen,
    onClose: handleClose,
    item: _objectSpread(_objectSpread({}, item), {}, {
      variations: variations
    }),
    modifiers: modifiers,
    modifierLists: itemModifierSets,
    onAddItem: addItem,
    disabled: cartLoading,
    images: images
    /* CatalogItemCartModal props */,
    modifierSets: itemModifierSets,
    variations: variations,
    cart: cart
  });
}
ItemContainer.defaultProps = defaultProps;
export default ItemContainer;